/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  MrfiktivBaseChartItemListViewmodelGen,
  MrfiktivBaseTrendAnalysisViewmodelGen,
  MrfiktivFleetAnalyticsControllerCoverageTypeAverageParamsGen,
  MrfiktivFleetAnalyticsControllerCoverageTypeParamsGen,
  MrfiktivFleetAnalyticsControllerDamageTypeAverageParamsGen,
  MrfiktivFleetAnalyticsControllerDamageTypeParamsGen,
  MrfiktivFleetAnalyticsControllerGetSubtotalByCoverageTypeWichDeductibleParamsGen,
  MrfiktivFleetAnalyticsControllerGetTotalSubtotalByCoverageTypeParamsGen,
  MrfiktivFleetAnalyticsControllerGetTotalSubtotalByDamageTypeParamsGen,
  MrfiktivFleetAnalyticsControllerGetTotalSubtotalByInvoiceSellerParamsGen,
  MrfiktivFleetAnalyticsControllerGetTotalSubtotalByVehicleParamsGen,
  MrfiktivFleetAnalyticsControllerReportWeekdayAnalysisPerPartnerParamsGen,
  MrfiktivFleetAnalyticsControllerReportWorkshopCompanyDistributionParamsGen,
  MrfiktivFleetAnalyticsControllerStatusDistributionParamsGen,
  MrfiktivFleetAnalyticsControllerStatusValueDistributionParamsGen,
  MrfiktivFleetAnalyticsControllerTrendAnalysisForPartnerParamsGen,
  MrfiktivFleetAnalyticsControllerTripTypeParamsGen,
  MrfiktivInvoiceChartItemListViewModelGen,
  MrfiktivInvoiceTypeItemListViewModelGen,
  MrfiktivMultipleIdsDtoGen,
  MrfiktivReportWeeklyAnalysisPerPartnerViewmodelGen,
  MrfiktivStatusDistributionAnalyticsViewModelGen,
  MrfiktivStatusValueDistributionAnalyticsViewModelGen,
  MrfiktivTotalDeductibleItemListViewModelGen
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class FleetAnalytics<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags Fleet Analytics
   * @name FleetAnalyticsControllerGetTotalSubtotalByDamageType
   * @summary Get sub total per damage type by partner id and time range
   * @request POST:/partner/{partnerId}/fleet/{fleetId}/analytics/invoice/damage-type
   * @secure
   * @response `200` `MrfiktivInvoiceTypeItemListViewModelGen` The found record
   * @response `403` `void` Forbidden.
   */
  fleetAnalyticsControllerGetTotalSubtotalByDamageType = (
    { partnerId, fleetId, ...query }: MrfiktivFleetAnalyticsControllerGetTotalSubtotalByDamageTypeParamsGen,
    data: MrfiktivMultipleIdsDtoGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivInvoiceTypeItemListViewModelGen, void>({
      path: `/partner/${partnerId}/fleet/${fleetId}/analytics/invoice/damage-type`,
      method: "POST",
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags Fleet Analytics
   * @name FleetAnalyticsControllerGetTotalSubtotalByCoverageType
   * @summary Get sub total per coverage type by partner id and time range
   * @request POST:/partner/{partnerId}/fleet/{fleetId}/analytics/invoice/coverage-type
   * @secure
   * @response `200` `MrfiktivInvoiceTypeItemListViewModelGen` The found record
   * @response `403` `void` Forbidden.
   */
  fleetAnalyticsControllerGetTotalSubtotalByCoverageType = (
    { partnerId, fleetId, ...query }: MrfiktivFleetAnalyticsControllerGetTotalSubtotalByCoverageTypeParamsGen,
    data: MrfiktivMultipleIdsDtoGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivInvoiceTypeItemListViewModelGen, void>({
      path: `/partner/${partnerId}/fleet/${fleetId}/analytics/invoice/coverage-type`,
      method: "POST",
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags Fleet Analytics
   * @name FleetAnalyticsControllerGetSubtotalByCoverageTypeWichDeductible
   * @summary Get total and deductible costs per coverage type
   * @request POST:/partner/{partnerId}/fleet/{fleetId}/analytics/invoice/total-deductible-coverage-costs
   * @secure
   * @response `200` `MrfiktivTotalDeductibleItemListViewModelGen` The found record
   * @response `403` `void` Forbidden.
   */
  fleetAnalyticsControllerGetSubtotalByCoverageTypeWichDeductible = (
    { partnerId, fleetId, ...query }: MrfiktivFleetAnalyticsControllerGetSubtotalByCoverageTypeWichDeductibleParamsGen,
    data: MrfiktivMultipleIdsDtoGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivTotalDeductibleItemListViewModelGen, void>({
      path: `/partner/${partnerId}/fleet/${fleetId}/analytics/invoice/total-deductible-coverage-costs`,
      method: "POST",
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags Fleet Analytics
   * @name FleetAnalyticsControllerTripType
   * @summary Returns the aggregation of trip types
   * @request POST:/partner/{partnerId}/fleet/{fleetId}/analytics/trip-type
   * @secure
   * @response `200` `MrfiktivBaseChartItemListViewmodelGen` Distribution of the trip type
   */
  fleetAnalyticsControllerTripType = (
    { partnerId, fleetId, ...query }: MrfiktivFleetAnalyticsControllerTripTypeParamsGen,
    data: MrfiktivMultipleIdsDtoGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivBaseChartItemListViewmodelGen, any>({
      path: `/partner/${partnerId}/fleet/${fleetId}/analytics/trip-type`,
      method: "POST",
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags Fleet Analytics
   * @name FleetAnalyticsControllerCoverageType
   * @summary Returns the aggregation of coverage types
   * @request POST:/partner/{partnerId}/fleet/{fleetId}/analytics/coverage-type
   * @secure
   * @response `200` `MrfiktivBaseChartItemListViewmodelGen` Distribution of the coverage type
   */
  fleetAnalyticsControllerCoverageType = (
    { partnerId, fleetId, ...query }: MrfiktivFleetAnalyticsControllerCoverageTypeParamsGen,
    data: MrfiktivMultipleIdsDtoGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivBaseChartItemListViewmodelGen, any>({
      path: `/partner/${partnerId}/fleet/${fleetId}/analytics/coverage-type`,
      method: "POST",
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags Fleet Analytics
   * @name FleetAnalyticsControllerDamageType
   * @summary Returns the aggregation of damage types
   * @request POST:/partner/{partnerId}/fleet/{fleetId}/analytics/damage-type
   * @secure
   * @response `200` `MrfiktivBaseChartItemListViewmodelGen` Distribution of the damage type
   */
  fleetAnalyticsControllerDamageType = (
    { partnerId, fleetId, ...query }: MrfiktivFleetAnalyticsControllerDamageTypeParamsGen,
    data: MrfiktivMultipleIdsDtoGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivBaseChartItemListViewmodelGen, any>({
      path: `/partner/${partnerId}/fleet/${fleetId}/analytics/damage-type`,
      method: "POST",
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags Fleet Analytics
   * @name FleetAnalyticsControllerDamageTypeAverage
   * @summary Returns the average total of damage types
   * @request POST:/partner/{partnerId}/fleet/{fleetId}/analytics/damage-type-average
   * @secure
   * @response `200` `MrfiktivBaseChartItemListViewmodelGen` Average total of the damage type
   */
  fleetAnalyticsControllerDamageTypeAverage = (
    { partnerId, fleetId, ...query }: MrfiktivFleetAnalyticsControllerDamageTypeAverageParamsGen,
    data: MrfiktivMultipleIdsDtoGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivBaseChartItemListViewmodelGen, any>({
      path: `/partner/${partnerId}/fleet/${fleetId}/analytics/damage-type-average`,
      method: "POST",
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags Fleet Analytics
   * @name FleetAnalyticsControllerCoverageTypeAverage
   * @summary Returns the average total of coverage types
   * @request POST:/partner/{partnerId}/fleet/{fleetId}/analytics/coverage-type-average
   * @secure
   * @response `200` `MrfiktivBaseChartItemListViewmodelGen` Average total of the coverage type
   */
  fleetAnalyticsControllerCoverageTypeAverage = (
    { partnerId, fleetId, ...query }: MrfiktivFleetAnalyticsControllerCoverageTypeAverageParamsGen,
    data: MrfiktivMultipleIdsDtoGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivBaseChartItemListViewmodelGen, any>({
      path: `/partner/${partnerId}/fleet/${fleetId}/analytics/coverage-type-average`,
      method: "POST",
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags Fleet Analytics
   * @name FleetAnalyticsControllerGetTotalSubtotalByInvoiceSeller
   * @summary Get inbound sub total per invoice seller
   * @request POST:/partner/{partnerId}/fleet/{fleetId}/analytics/invoice/seller
   * @secure
   * @response `200` `MrfiktivInvoiceChartItemListViewModelGen` The found record
   * @response `403` `void` Forbidden.
   */
  fleetAnalyticsControllerGetTotalSubtotalByInvoiceSeller = (
    { partnerId, fleetId, ...query }: MrfiktivFleetAnalyticsControllerGetTotalSubtotalByInvoiceSellerParamsGen,
    data: MrfiktivMultipleIdsDtoGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivInvoiceChartItemListViewModelGen, void>({
      path: `/partner/${partnerId}/fleet/${fleetId}/analytics/invoice/seller`,
      method: "POST",
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags Fleet Analytics
   * @name FleetAnalyticsControllerStatusDistribution
   * @summary Returns the number of damage reports per progress status
   * @request POST:/partner/{partnerId}/fleet/{fleetId}/analytics/status-distribution
   * @secure
   * @response `200` `MrfiktivStatusDistributionAnalyticsViewModelGen` Distribution of the impact type
   */
  fleetAnalyticsControllerStatusDistribution = (
    { partnerId, fleetId, ...query }: MrfiktivFleetAnalyticsControllerStatusDistributionParamsGen,
    data: MrfiktivMultipleIdsDtoGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivStatusDistributionAnalyticsViewModelGen, any>({
      path: `/partner/${partnerId}/fleet/${fleetId}/analytics/status-distribution`,
      method: "POST",
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags Fleet Analytics
   * @name FleetAnalyticsControllerStatusValueDistribution
   * @summary Returns the number of damage reports per `status` property
   * @request POST:/partner/{partnerId}/fleet/{fleetId}/analytics/status-value-distribution
   * @secure
   * @response `200` `MrfiktivStatusValueDistributionAnalyticsViewModelGen` Distribution of the impact type
   */
  fleetAnalyticsControllerStatusValueDistribution = (
    { partnerId, fleetId, ...query }: MrfiktivFleetAnalyticsControllerStatusValueDistributionParamsGen,
    data: MrfiktivMultipleIdsDtoGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivStatusValueDistributionAnalyticsViewModelGen, any>({
      path: `/partner/${partnerId}/fleet/${fleetId}/analytics/status-value-distribution`,
      method: "POST",
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags Fleet Analytics
   * @name FleetAnalyticsControllerReportWeekdayAnalysisPerPartner
   * @summary Returns the aggregation of reports on a weekly basis.
   * @request POST:/partner/{partnerId}/fleet/{fleetId}/analytics/weekday-analysis
   * @secure
   * @response `200` `MrfiktivReportWeeklyAnalysisPerPartnerViewmodelGen` Distribution of report per weekday
   */
  fleetAnalyticsControllerReportWeekdayAnalysisPerPartner = (
    { partnerId, fleetId, ...query }: MrfiktivFleetAnalyticsControllerReportWeekdayAnalysisPerPartnerParamsGen,
    data: MrfiktivMultipleIdsDtoGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivReportWeeklyAnalysisPerPartnerViewmodelGen, any>({
      path: `/partner/${partnerId}/fleet/${fleetId}/analytics/weekday-analysis`,
      method: "POST",
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags Fleet Analytics
   * @name FleetAnalyticsControllerTrendAnalysisForPartner
   * @summary Return partner trendanalysis for day, week and 30 days
   * @request POST:/partner/{partnerId}/fleet/{fleetId}/analytics/trend
   * @secure
   * @response `200` `MrfiktivBaseTrendAnalysisViewmodelGen` Report trend data
   * @response `400` `void` General error if request is not working.
   */
  fleetAnalyticsControllerTrendAnalysisForPartner = (
    { partnerId, fleetId, ...query }: MrfiktivFleetAnalyticsControllerTrendAnalysisForPartnerParamsGen,
    data: MrfiktivMultipleIdsDtoGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivBaseTrendAnalysisViewmodelGen, void>({
      path: `/partner/${partnerId}/fleet/${fleetId}/analytics/trend`,
      method: "POST",
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags Fleet Analytics
   * @name FleetAnalyticsControllerGetTotalSubtotalByVehicle
   * @summary Get inbound sub total per vehicle
   * @request POST:/partner/{partnerId}/fleet/{fleetId}/analytics/vehicle
   * @secure
   * @response `200` `MrfiktivInvoiceChartItemListViewModelGen` The found record
   * @response `403` `void` Forbidden.
   */
  fleetAnalyticsControllerGetTotalSubtotalByVehicle = (
    { partnerId, fleetId, ...query }: MrfiktivFleetAnalyticsControllerGetTotalSubtotalByVehicleParamsGen,
    data: MrfiktivMultipleIdsDtoGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivInvoiceChartItemListViewModelGen, void>({
      path: `/partner/${partnerId}/fleet/${fleetId}/analytics/vehicle`,
      method: "POST",
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags Fleet Analytics
   * @name FleetAnalyticsControllerReportWorkshopCompanyDistribution
   * @summary Returns the number of reports per `workshopCompanyId` property associated with flag `isAffiliate`
   * @request POST:/partner/{partnerId}/fleet/{fleetId}/analytics/workshop-company-affiliate
   * @secure
   * @response `200` `MrfiktivBaseChartItemListViewmodelGen` The found record
   * @response `403` `void` Forbidden.
   */
  fleetAnalyticsControllerReportWorkshopCompanyDistribution = (
    { partnerId, fleetId, ...query }: MrfiktivFleetAnalyticsControllerReportWorkshopCompanyDistributionParamsGen,
    data: MrfiktivMultipleIdsDtoGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivBaseChartItemListViewmodelGen, void>({
      path: `/partner/${partnerId}/fleet/${fleetId}/analytics/workshop-company-affiliate`,
      method: "POST",
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
}
